import { Dialog as SheetPrimitive } from '@base-ui/react/dialog';

export type SheetProps = SheetPrimitive.Root.Props;

const Sheet = ({ ...props }: SheetProps) => {
  return <SheetPrimitive.Root data-slot="sheet" {...props} />;
};

export default Sheet;
